import { getPieceTheme } from "../game/pieceThemes";

function CrownIcon() {
  return (
    <span
      className="absolute left-1/2 top-1/2 crown-drop pointer-events-none"
      style={{ width: "70%", height: "70%", transform: "translate(-50%, -50%)" }}
    >
      <svg viewBox="0 0 24 24" fill="none" className="w-full h-full" aria-hidden>
        <path
          d="M3 8l4 4 5-7 5 7 4-4-2 11H5L3 8z"
          fill="#f5a623"
          stroke="#1a100c"
          strokeWidth="1.2"
          strokeLinejoin="round"
        />
        <circle cx="12" cy="6" r="1.2" fill="#fff8dc" />
      </svg>
    </span>
  );
}

function ShellFace({ spec }) {
  return (
    <>
      <span
        className="absolute inset-0 rounded-[48%_52%_46%_54%]"
        style={{
          background: `radial-gradient(ellipse 85% 70% at 35% 28%, #ffffff 0%, ${spec.shell} 45%, ${spec.shellEdge} 100%)`,
          boxShadow: `inset 0 -3px 8px ${spec.ridge}, inset 2px 2px 6px rgba(255,255,255,0.5)`,
        }}
      />
      <svg
        viewBox="0 0 40 40"
        className="absolute inset-[8%] w-[84%] h-[84%] pointer-events-none opacity-45"
        aria-hidden
      >
        <path
          d="M20 6 C28 14, 32 22, 20 34 C8 22, 12 14, 20 6"
          fill="none"
          stroke={spec.shellEdge}
          strokeWidth="1.2"
        />
        <path
          d="M20 10 C25 16, 27 22, 20 30 C13 22, 15 16, 20 10"
          fill="none"
          stroke={spec.ridge}
          strokeWidth="0.8"
        />
      </svg>
    </>
  );
}

function PebbleFace({ spec }) {
  return (
    <>
      <span
        className="absolute inset-0"
        style={{
          borderRadius: "42% 58% 55% 45% / 48% 42% 58% 52%",
          background: `radial-gradient(circle at 28% 22%, ${spec.pebbleLight} 0%, ${spec.pebble} 42%, ${spec.pebbleDark} 100%)`,
          boxShadow: `inset -2px -3px 6px rgba(0,0,0,0.45), inset 2px 2px 4px ${spec.speck}`,
        }}
      />
      <span
        className="absolute w-[18%] h-[14%] rounded-full top-[22%] left-[30%] pointer-events-none"
        style={{ background: spec.speck }}
      />
      <span
        className="absolute w-[12%] h-[10%] rounded-full top-[55%] left-[52%] pointer-events-none"
        style={{ background: spec.speck, opacity: 0.7 }}
      />
    </>
  );
}

/**
 * Renders a Faanuu piece (coquillage or galet) with optional Ari'i crown.
 */
export default function Piece({
  owner,
  king = false,
  themeId,
  selected = false,
  mustCapture = false,
  hintsOn = true,
  className = "",
  style = {},
  size = "58%",
  showHints = true,
  "data-testid": dataTestId,
}) {
  const theme = getPieceTheme(themeId);
  const spec = owner === "A" ? theme.A : theme.B;

  return (
    <span
      data-testid={dataTestId}
      className={`absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 piece-shadow transition-transform block ${
        selected ? "scale-110 ring-2 ring-amber-300 ring-offset-2 ring-offset-[#3a2410]" : ""
      } ${showHints && hintsOn && mustCapture && !selected ? "ring-2 ring-orange-500" : ""} ${className}`}
      style={{
        width: size,
        height: size,
        border: spec.border,
        boxShadow: spec.shadow,
        borderRadius: spec.kind === "pebble" ? "42% 58% 55% 45% / 48% 42% 58% 52%" : "48% 52% 46% 54%",
        ...style,
      }}
    >
      <span className="relative block w-full h-full overflow-hidden" style={{ borderRadius: "inherit" }}>
        {spec.kind === "shell" ? <ShellFace spec={spec} /> : <PebbleFace spec={spec} />}
        {king && <CrownIcon />}
      </span>
    </span>
  );
}

/** Small static preview for preference picker */
export function PiecePreview({ owner, themeId, size = 40 }) {
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }}>
      <Piece
        owner={owner}
        themeId={themeId}
        size="100%"
        showHints={false}
        className="!relative !left-0 !top-0 !translate-x-0 !translate-y-0"
      />
    </div>
  );
}
